module.exports = __webpack_public_path__ + "static/media/tooltipInfo.86d76f30.svg";